import { useAlerting, useTranslation } from "src/hooks";
import { AddWalletBalanceMonitorFields } from "..";
import { snakeCase } from "lodash";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

function useValidation() {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t, tc } = useTranslation(translatePrefix);
  const { alerting } = useAlerting();

  const validate = (fields: AddWalletBalanceMonitorFields) => {
    try {
      const { thresholdLower, thresholdUpper, addressBookFields, ...rest } =
        fields;

      const apiParams = {
        ...rest,
        walletAddress: addressBookFields.to_address,
      };

      Object.entries(apiParams).forEach(([key, value]) => {
        if (!value) {
          throw tc("phSelection", { fieldName: t(snakeCase(key)) });
        }
      });

      if (!thresholdLower && !thresholdUpper) {
        throw t("no_threshold_warning");
      }

      if (thresholdLower && thresholdUpper) {
        if (Number(fields.thresholdLower) >= Number(fields.thresholdUpper)) {
          throw t("invalid_threshold_warning");
        }
      }
    } catch (message: any) {
      alerting("warning", message);
      return false;
    }

    return true;
  };

  return { validate };
}

export default useValidation;
